import { get, post, put, del } from './api';

// Create a new customer
export const createCustomer = (data) => {
  return post('/customers', data);
};

export const getAllCustomers = (
  page = 1,
  search = '',
  sortField = 'id',
  sortOrder = 'desc',
  all = false
) => {
  const params = new URLSearchParams();
  if (all) {
    params.append('all', 'true');
  } else {
    params.append('page', page);
    params.append('all', 'false');
  }

  if (search && search.trim()) {
    params.append('search', search.trim());
  }

  if (sortField) {
    params.append('sort_field', sortField);
    params.append('sort_by', sortField);
  }
  if (sortOrder) params.append('sort_order', sortOrder);

  return get(`/customers?${params.toString()}`);
};

// Fetch or search all customers without pagination (for order forms / select dropdowns)
export const getAllCustomerList = (search = '') => {
  return getAllCustomers(1, search, 'name', 'asc', true);
};


// Get a customer by ID
export const getCustomerById = (id) => {
  return get(`/customers/${id}`);
};

// Update a customer
export const updateCustomer = (id, data) => {
  return put(`/customers/${id}`, data);
};

// Delete a customer 
export const deleteCustomer = (id) => {
  return del(`/customers/${id}`);
};

// gst 
export const fetchCustomerByGST = (gstNumber) => {
  return get(`/customers/gst/${gstNumber}`);
};



// download customer import template
export const downloadCustomerTemplate = () => {
  return get('/customers/import/template', {
    responseType: 'blob', 
  });
};

// import customer in bulk
export const importCustomer = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return post('/customers/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 300000, 
  });
};